import { useState } from "react";
import { Input } from "antd";
import Vector from "../assets/Vector.svg";
import _, { template } from "lodash";
import "./ContentResultManual.scss";

const ContentResultManual = ({ templateData, manualEntries, setManualEntries, isPenalty }) => {
  const goalShots = templateData?.data?.dynamic?.goalShots;
  const goals = goalShots?.filter(({ typeId }) => typeId === 16);
  const homeTeam = templateData?.event.home;
  const awayTeam = templateData?.event.away;

  const homeTeamId = homeTeam?.id;
  const awayTeamId = awayTeam?.id;

  const lineUp = templateData?.data?.dynamic?.lineUp;
  const homeLineUp = lineUp?.find((l) => l.contestantId === homeTeamId)?.player;
  const awayLineUp = lineUp?.find((l) => l.contestantId === awayTeamId)?.player;
  const homeGoals = goals
    // .filter(goal => goal.contestantId === homeTeamId)
    .filter(g => (g.contestantId === homeTeamId && !g.isOwnGoal) || (g.contestantId !== homeTeamId && g.isOwnGoal))
    .map(goal => {
      let player = homeLineUp.find(p => p.playerId === goal.playerId);
      if (goal.isOwnGoal) {
        player = awayLineUp.find(p => p.playerId === goal.playerId);
      }
      const isPenalty = goal?.isPenalty;
      const isOwnGoal = goal?.isOwnGoal;
      return {
        min: goal.timeMin?.toString() || '',
        name: (player?.shortLastName || goal.scorerName || '') + (isPenalty ? " (P)" : isOwnGoal ? " (OG)" : "") // fallback if player not found
      };
    });
  const awayGoals = goals
    .filter(g => (g.contestantId === awayTeamId && !g.isOwnGoal) || (g.contestantId !== awayTeamId && g.isOwnGoal))
    .map(goal => {
      let player = awayLineUp.find(p => p.playerId === goal.playerId);
      if (goal.isOwnGoal) {
        player = homeLineUp.find(p => p.playerId === goal.playerId);
      }
      const isPenalty = goal?.isPenalty;
      const isOwnGoal = goal?.isOwnGoal;
      return {
        min: goal.timeMin?.toString() || '',
        name: (player?.shortLastName || goal.scorerName || '') + (isPenalty ? " (P)" : isOwnGoal ? " (OG)" : "")  // fallback if player not found
      };
    });
  // Initial score from data
  let _hScore = homeGoals?.length ?? 0;
  let _aScore = awayGoals?.length ?? 0;
  let _penHScore = 0;
  let _penAScore = 0;

  if (manualEntries) {
    const scores = manualEntries.scores;
    _hScore = scores?.home ?? _hScore;
    _aScore = scores?.away ?? _aScore;
    _penHScore = scores?.penHome ?? _penHScore;
    _penAScore = scores?.penAway ?? _penAScore;
  }

  const [hScore, setHScore] = useState(_hScore);
  const [aScore, setAScore] = useState(_aScore);
  const [penHScore, setPenHScore] = useState(_penHScore);
  const [penAScore, setPenAScore] = useState(_penAScore);


  let initialHomeTeamScores = Array.from({ length: Math.max(_hScore, 5) }, () => ({ min: '', name: '' }));

  let initialAwayTeamScores = Array.from({ length: Math.max(_aScore, 5) }, () => ({ min: '', name: '' }));


  if (manualEntries) {
    initialHomeTeamScores = manualEntries.players?.home || initialHomeTeamScores;
    initialAwayTeamScores = manualEntries.players?.away || initialAwayTeamScores;
  }

  const [homeTeamScores, setHomeTeamScores] = useState(initialHomeTeamScores);
  const [awayTeamScores, setAwayTeamScores] = useState(initialAwayTeamScores);
  const onHValueChange = (e) => {
    const value = parseInt(e.target.value, 10);
    const newLength = Math.max(5, isNaN(value) ? 0 : value);
    setHScore(value);

    const updatedHomeScores = (() => {
      const current = [...homeTeamScores];
      if (newLength > current.length) {
        const toAdd = Array.from({ length: newLength - current.length }, () => ({ min: '', name: '' }));
        return [...current, ...toAdd];
      } else {
        return current.slice(0, newLength);
      }
    })();

    setHomeTeamScores(updatedHomeScores);
    setManualEntries({
      scores: {
        home: value,
        away: aScore,
        penHome: penHScore,
        penAway: penAScore,
      },
      players: {
        home: updatedHomeScores,
        away: awayTeamScores
      }
    });
  };


  const onAValueChange = (e) => {
    const value = parseInt(e.target.value, 10);
    const newLength = Math.max(5, isNaN(value) ? 0 : value);
    setAScore(value);

    const updatedAwayScores = (() => {
      const current = [...awayTeamScores];
      if (newLength > current.length) {
        const toAdd = Array.from({ length: newLength - current.length }, () => ({ min: '', name: '' }));
        return [...current, ...toAdd];
      } else {
        return current.slice(0, newLength);
      }
    })();


    setAwayTeamScores(updatedAwayScores);
    setManualEntries({
      scores: {
        home: hScore,
        away: value,
        penHome: penHScore,
        penAway: penAScore,
      },
      players: {
        home: homeTeamScores,
        away: updatedAwayScores
      }
    });
  };

  const onHPlayerChange = (index, min, name) => {
    const newHomeTeamScores = [...homeTeamScores];
    if (min !== null) newHomeTeamScores[index].min = min;
    if (name !== null) newHomeTeamScores[index].name = name;

    setHomeTeamScores(newHomeTeamScores);
    setManualEntries({
      scores: {
        home: hScore,
        away: aScore,
        penHome: penHScore,
        penAway: penAScore,
      },
      players: {
        home: newHomeTeamScores,
        away: awayTeamScores
      }
    });
  };

  const onAPlayerChange = (index, min, name) => {
    const newAwayTeamScores = [...awayTeamScores];
    if (min !== null) newAwayTeamScores[index].min = min;
    if (name !== null) newAwayTeamScores[index].name = name;

    setAwayTeamScores(newAwayTeamScores);
    setManualEntries({
      scores: {
        home: hScore,
        away: aScore,
        penHome: penHScore,
        penAway: penAScore,
      },
      players: {
        home: homeTeamScores,
        away: newAwayTeamScores
      }
    });
  };


  const onPenHValueChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setPenHScore(value);

    setManualEntries({
      ...manualEntries,
      scores: {
        ...manualEntries?.scores,
        penHome: value,
        penAway: penAScore
      },
    });
  };

  const onPenAValueChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setPenAScore(value);

    setManualEntries({
      ...manualEntries,
      scores: {
        ...manualEntries?.scores,
        penHome: penHScore,
        penAway: value
      },
    });
  };

  return (
    <div>
      <div className="content-tab">
        <div className="content-header">
          <div className="content-tab-title">
            Full Time.
          </div>
          <div className="add-score-form">
            <div className="input-pair">
              <Input
                type="number"
                className="half-input"
                value={hScore}
                onChange={onHValueChange}
              />
              <span className="separator">-</span>
              <Input
                type="number"
                className="half-input"
                value={aScore}
                onChange={onAValueChange}
              />
            </div>
          </div>
        </div>
        <div className="add-player-container">
          <div className="add-player team-home">
            <div className="add-player-title">
              Home
            </div>
            {homeTeamScores.map((value, index) => {
              const isActive = index < hScore;
              return (
                <div className={`add-player-item ${!isActive ? 'inactive' : ''}`} key={index}>
                  <span>{index + 1}</span>
                  <Input
                    className="min"
                    placeholder="Min"
                    value={value.min}
                    onChange={(e) => isActive && onHPlayerChange(index, e.target.value, null)}
                    disabled={!isActive}
                  />
                  <Input
                    className="name"
                    placeholder="Name"
                    value={value.name}
                    onChange={(e) => isActive && onHPlayerChange(index, null, e.target.value)}
                    disabled={!isActive}
                  />
                </div>
              );
            })}
          </div>

          <div className="add-player team-away">
            <div className="add-player-title">
              Away
            </div>
            {awayTeamScores.map((value, index) => {
              const isActive = index < aScore;
              return (
                <div className={`add-player-item ${!isActive ? 'inactive' : ''}`} key={index}>
                  <span>{index + 1}</span>
                  <Input
                    className="min"
                    placeholder="Min"
                    value={value.min}
                    onChange={(e) => isActive && onAPlayerChange(index, e.target.value, null)}
                    disabled={!isActive}
                  />
                  <Input
                    className="name"
                    placeholder="Name"
                    value={value.name}
                    onChange={(e) => isActive && onAPlayerChange(index, null, e.target.value)}
                    disabled={!isActive}
                  />
                </div>
              );
            })}
          </div>
        </div>
        {
          isPenalty && <div className="penalty-tab-container">
            <div className="penalty-tab-title">
              PEN.
            </div>
            <div className="add-score-form">
              <div className="input-pair">
                <Input
                  type="number"
                  className="half-input"
                  value={penHScore}
                  onChange={onPenHValueChange}
                />
                <span className="separator">-</span>
                <Input
                  type="number"
                  className="half-input"
                  value={penAScore}
                  onChange={onPenAValueChange}
                />
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  );
};

export default ContentResultManual;